import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";

const Vulnerability = () => {
  const location = useLocation();
  const { title, description, codeSnippet, updatedCodeSnippet } =
    location.state || {};

  const processDescription = (description) => {
    var parts = description.split("```");

    var updatedDescription = "";
    var updatedCodeSnippet = "";

    // Loop through the parts
    parts.forEach((part, index) => {
      if (index % 2 === 0) {
        updatedDescription += part.replace(/\*\*/g, "").replace(/\*/g, "\n*");
      } else {
        updatedCodeSnippet = part;
      }
    });

    if (updatedCodeSnippet) {
      updatedDescription = updatedDescription.replace(updatedCodeSnippet, "");
    }

    return {
      updatedDescription: updatedDescription.trim(),
      updatedCodeSnippet: updatedCodeSnippet.trim(),
    };
  };

  var descriptionUpdated = processDescription(description);

  console.log(updatedCodeSnippet);

  useEffect(() => {
    hljs.highlightAll();
  }, [codeSnippet, updatedCodeSnippet]);

  return (
    <div>
      <h1>
        <span class="orangeFixed">{title}</span>
      </h1>
      <div class="container">
        <p>Description: {descriptionUpdated.updatedDescription}</p>
      </div>
      <div style={{ margin: "20px 0" }}></div>{" "}
      {/* Add margin on top and bottom */}
      <div style={{ marginLeft: "20px", marginRight: "20px" }}>
        {" "}
        {/* Add margin to left and right */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "48%" }}>
            <h3>Original Code Snippet:</h3>
            <pre>
              <code>{codeSnippet}</code>
            </pre>
          </div>
          <div style={{ width: "48%" }}>
            <h3>Updated Code Snippet:</h3>
            <pre>
              <code>{updatedCodeSnippet}</code>
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vulnerability;
